import { BannerType, GlobalBannerDynamic, useGlobalBannerStore } from '@frontend/global-info-banner';
import { useTranslation } from '@frontend/i18n';
import { useAppScopeStore } from '@frontend/scope';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { useBrandVerification } from '../../hooks/use-brand-verification';
import { useTenDLCBannerStore } from '../../stores';

export const BusinessInformationBanner = () => {
  const { t } = useTranslation('messages');
  const { selectedLocationIds, accessibleLocationData } = useAppScopeStore();
  const { navigate } = useSettingsNavigate();
  const { removeBanner } = useGlobalBannerStore(['removeBanner']);
  const { unverifiedCount } = useBrandVerification({
    locationIds: selectedLocationIds,
  });
  const devOrDemoOpsTypes: NonNullable<(typeof accessibleLocationData)[number]>['opsType'][] = ['DEV', 'DEMO', 'TEST'];
  const allLocationsAreDevOrDemo = selectedLocationIds.every((locationId) => {
    const opsType = accessibleLocationData[locationId]?.opsType ?? 'OPS_TYPE_INVALID';
    return devOrDemoOpsTypes.includes(opsType);
  });
  const id = 'business-verification-banner';
  const { dismissedLocationIds, dismissLocationIds } = useTenDLCBannerStore();
  const allLocationsAreDismissed = selectedLocationIds.every((locationId) => dismissedLocationIds.includes(locationId));

  const banners = [
    {
      condition: !!unverifiedCount && !allLocationsAreDismissed,
      id,
      title: t('Business Information: 0 of 2 Required Settings Complete!'),
      message: t('Your business needs to be verified with Weave. Action is required to complete your account setup.'),
      action: {
        label: 'Start Business Verification',
        onClick: () => navigate({ to: '/organization/business-verification' }),
      },
      type: 'error',
      trackingId: 'business-verification-banner-click',
      isDismissable: allLocationsAreDevOrDemo,
      onDismiss: () => {
        removeBanner(id);
        dismissLocationIds(selectedLocationIds);
      },
    },
  ];

  return (
    <>
      {banners.map(
        ({ condition, id, title, message, action, type, trackingId, isDismissable, onDismiss }) =>
          condition && (
            <GlobalBannerDynamic
              key={id}
              id={id}
              surfaceId='banner.messaging-compliance'
              type={type as BannerType}
              title={title}
              message={message}
              action={action ?? undefined}
              isDismissible={isDismissable}
              trackingId={trackingId}
              onDismiss={onDismiss}
            />
          )
      )}
    </>
  );
};
